import { render, staticRenderFns } from "./NotifyDialog.vue?vue&type=template&id=81a2dff2&scoped=true"
import script from "./NotifyDialog.vue?vue&type=script&lang=ts"
export * from "./NotifyDialog.vue?vue&type=script&lang=ts"
import style0 from "./NotifyDialog.vue?vue&type=style&index=0&id=81a2dff2&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "81a2dff2",
  null
  
)

export default component.exports